import { groupByValues } from '@/metrics/constants'

export const groupByOptions = [
  { value: groupByValues.products, label: 'Productos' },
  { value: groupByValues.variants, label: 'Variantes' },
  { value: groupByValues.categories, label: 'Categorías' },
  { value: groupByValues.types, label: 'Tipos' },
  { value: groupByValues.collections, label: 'Colecciones' },
]

export const nonShopifyExcludedValues = [groupByValues.collections, groupByValues.types]
